// apps/web/src/pages/BlockedUsers/BlockedUsers.jsx
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import SafetyService from '../../services/safetyService';
import styles from './BlockedUsers.module.css';

export default function BlockedUsers() {
    const navigate = useNavigate();
    const [blocked, setBlocked] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        SafetyService.getBlockedUsers()
            .then(data => setBlocked(data ?? []))
            .catch(() => {})
            .finally(() => setLoading(false));
    }, []);

    const handleUnblock = async (user) => {
        if (!window.confirm(`Unblock @${user.username}? They'll be able to see your profile again.`)) return;
        try {
            await SafetyService.unblockUser(user.id);
            setBlocked(prev => prev.filter(u => u.id !== user.id));
        } catch {
            alert('Could not unblock. Please try again.');
        }
    };

    return (
        <main className={styles.page}>
            <div className={styles.inner}>
                <div className={styles.header}>
                    <button className={styles.backBtn} onClick={() => navigate('/settings')}>← Back</button>
                    <h1 className={styles.title}>Blocked Users</h1>
                    <div style={{ width: 60 }} />
                </div>

                {loading ? (
                    <p className={styles.empty}>Loading…</p>
                ) : blocked.length === 0 ? (
                    <div className={styles.emptyState}>
                        <span>🚫</span>
                        <p>You haven't blocked anyone.</p>
                    </div>
                ) : (
                    <ul className={styles.list}>
                        {blocked.map(user => (
                            <li key={user.id} className={styles.row}>
                                {user.avatar_url ? (
                                    <img src={user.avatar_url} alt={user.username} className={styles.avatar} />
                                ) : (
                                    <div className={styles.avatarFallback}>
                                        {(user.display_name || user.username || '?')[0].toUpperCase()}
                                    </div>
                                )}
                                <div className={styles.info}>
                                    <span className={styles.displayName}>{user.display_name || user.username}</span>
                                    <span className={styles.username}>@{user.username}</span>
                                </div>
                                <button className={styles.unblockBtn} onClick={() => handleUnblock(user)}>
                                    Unblock
                                </button>
                            </li>
                        ))}
                    </ul>
                )}
            </div>
        </main>
    );
}